import { gql } from '@apollo/client'

export const GENERATE_CHANGE_PASSWORD_URL = gql`
  mutation GenerateChangePasswordUrl {
    generateChangePasswordUrl(input: {}) {
      url
      errors
    }
  }
`
